// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YCCROL5lgaPcXGBgUxtJ {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  /* A published dashboard is content on a page, not a canvas. The tiles are
     white, so the page behind them is the warm neutral the rest of Curio uses
     for a surface a card sits on. On pure white the tiles had no edge at all
     and the page read as an empty canvas with a box floating on it. */
  background-color: var(--curio-surface-alt);
  /* The bar is \`position: fixed\` (DashboardTopBar.module.css), so the page
     reserves its height rather than laying it out. The canvas box below is what
     the fit and the resize observer measure, so it must not extend under the
     bar. */
  padding-top: var(--curio-top-bar-height);
  box-sizing: border-box;
}

._KG6pntBEjDVjzBeXlSE {
  position: relative;
  flex: 1;
  min-height: 0;
}

.Sg7zGd_pCOinsfK5R_cb {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 24px;
  text-align: center;
  color: #55565c;
  font-size: 14px;
  /* Above the (empty) canvas, but under the bar and its dropdowns. */
  z-index: 10;
  background-color: var(--curio-surface-alt);
}

.rYIh8dgiTXkaZIWZa9It {
  font-size: 18px;
  font-weight: 600;
  color: #1E1F23;
}

/* Why the server would not build the page: its paragraphs, and the indented
   rows that name the heaviest nodes, as the server wrote them. */
.DIywirV0lC6899fVSOPY {
  max-width: 640px;
  white-space: pre-wrap;
  text-align: left;
}

/* A quiet secondary action rather than a default browser link: this is the
   only thing on an otherwise empty page, and a blue underline was the one
   piece of unstyled chrome left on it. */
.W6Pz8SHH3JvjuJ8139JM {
  margin-top: 6px;
  padding: 7px 16px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-md);
  background-color: var(--curio-card-bg);
  color: var(--curio-text-primary);
  font-size: var(--curio-font-size-md);
  font-weight: 500;
  text-decoration: none;
}

.W6Pz8SHH3JvjuJ8139JM:hover {
  background-color: var(--curio-surface-muted);
  color: var(--curio-text-primary);
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/DashboardPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ;;;sEAGoE;EACpE,0CAA0C;EAC1C;;;WAGS;EACT,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mEAAmE;EACnE,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;iEACiE;AACjE;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;yCAEyC;AACzC;EACE,eAAe;EACf,iBAAiB;EACjB,4CAA4C;EAC5C,qCAAqC;EACrC,sCAAsC;EACtC,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,qBAAqB;AACvB","sourcesContent":[".page {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100vw;\n  /* A published dashboard is content on a page, not a canvas. The tiles are\n     white, so the page behind them is the warm neutral the rest of Curio uses\n     for a surface a card sits on. On pure white the tiles had no edge at all\n     and the page read as an empty canvas with a box floating on it. */\n  background-color: var(--curio-surface-alt);\n  /* The bar is `position: fixed` (DashboardTopBar.module.css), so the page\n     reserves its height rather than laying it out. The canvas box below is what\n     the fit and the resize observer measure, so it must not extend under the\n     bar. */\n  padding-top: var(--curio-top-bar-height);\n  box-sizing: border-box;\n}\n\n.canvas {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n}\n\n.state {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 24px;\n  text-align: center;\n  color: #55565c;\n  font-size: 14px;\n  /* Above the (empty) canvas, but under the bar and its dropdowns. */\n  z-index: 10;\n  background-color: var(--curio-surface-alt);\n}\n\n.stateTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1E1F23;\n}\n\n/* Why the server would not build the page: its paragraphs, and the indented\n   rows that name the heaviest nodes, as the server wrote them. */\n.stateReason {\n  max-width: 640px;\n  white-space: pre-wrap;\n  text-align: left;\n}\n\n/* A quiet secondary action rather than a default browser link: this is the\n   only thing on an otherwise empty page, and a blue underline was the one\n   piece of unstyled chrome left on it. */\n.stateLink {\n  margin-top: 6px;\n  padding: 7px 16px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-md);\n  background-color: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  font-size: var(--curio-font-size-md);\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.stateLink:hover {\n  background-color: var(--curio-surface-muted);\n  color: var(--curio-text-primary);\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `YCCROL5lgaPcXGBgUxtJ`,
	"canvas": `_KG6pntBEjDVjzBeXlSE`,
	"state": `Sg7zGd_pCOinsfK5R_cb`,
	"stateTitle": `rYIh8dgiTXkaZIWZa9It`,
	"stateReason": `DIywirV0lC6899fVSOPY`,
	"stateLink": `W6Pz8SHH3JvjuJ8139JM`
};
export default ___CSS_LOADER_EXPORT___;
